<template>
    <div>
        <main
            v-if="authorData && !notFound"
            class="m-blog"
        >
            <y-container>
                <y-author-hero
                    v-if="authorData && authorData[0].publisher"
                    :publisher="authorData[0].publisher"
                />
                <y-popular-articles />
            </y-container>

            <y-categories />
            <y-container>
                <y-email-subscription />
            </y-container>
        </main>
        <page-not-found v-if="notFound" />
    </div>
</template>

<script >
    import PageMixin from '@groot-nodes/mixins/Page.js';
    import YEmailSubscription from '@modules/blog/components/EmailSubscription/EmailSubscription.vue';
    import YPopularArticles from '@modules/blog/components/PopularArticles/PopularArticles.vue';
    import YAuthorHero from '@modules/blog/components/AuthorHero/AuthorHero.vue';
    import YCategories from '@modules/blog/components/Categories/Categories.vue';
    import PageNotFound from '@components/PageNotFound.vue';

    export default {
        name      : 'BlogAuthorPage',
        components: {
            PageNotFound,
            YCategories,
            YEmailSubscription,
            YPopularArticles,
            YAuthorHero,
        },

        mixins: [PageMixin],

        /**
         * @inheritDoc
         */
        metaInfo() {
            return {
                title: this.title,

                meta: [
                    {
                        property: 'og:title',
                        content : this.heroContent.name_full,
                        vmid    : 'og:title',
                    },
                    {
                        property: 'og:description',
                        content : this.heroContent.biography,
                        vmid    : 'og:desctiption',
                    },
                    {
                        property: 'og:image',
                        content : this.graphImage,
                        vmid    : 'og:image',
                    },
                    {
                        property: 'og:url',
                        content : this.$route.fullPath,
                        vmid    : 'og:url',
                    },
                ],
            };
        },
        /**
         *
         * @inheritDoc
         */
        data() {
            return {
                authorData    : null,
                topMargin     : null,
                categoriesData: null,
                titleMeta     : null,
                notFound      : false,
                heroContent   : '',
                graphImage    : '',
            };
        },
        computed: {
            /**
             * Meta info title
             *
             * @returns {string}
             */
            title() {
                return this.titleMeta || this.$t('blog.title');
            },
        },

        /**
         *
         * @inheritDoc
         */
        methods: {

            /**
             * fetch author data
             *
             * @returns {Promise}
             */
            fetch() {
                this.$wait.start('loading-single-blog');
                const authorData = this.$services.Content.postList({
                    type     : 'blog',
                    including: ['id', 'publisher'],
                    user_id  : this.$route.params.id,
                    limit    : 1,
                    locale   : this.$i18n.locale,
                }).catch((error) => {
                    if (error.response.data.status === '404') {
                        this.notFound = true;
                    }
                    this.handleError(error);
                });

                return Promise.all([authorData])
                    .then((responses) => {
                        if (this.handleReq(responses, 0)) {
                            if (!responses[0].data.results.length) {
                                this.notFound = true;
                            }
                            this.authorData = responses[0].data.results;
                            this.heroContent = this.authorData[0].publisher;
                            this.graphImage = this.heroContent.avatar[0].link;
                            this.titleMeta = this.authorData[0].publisher.name_full;
                        }
                    })
                    .catch((error) => {
                        this.handleError(error);
                    })
                    .finally(() => {
                        this.$wait.end('loading-single-blog');
                    });
            },
        },
    };

</script>

<style lang="scss" src="../scss/blog.scss"/>
